// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { lightFormat as fn } from "../lightFormat.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const lightFormat = convertToFP(fn, 2);

// Fallback for modularized imports:
export default lightFormat;
